import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=65dd717d&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=65dd717d&lang=scss"

import exportComponent from "D:\\Project\\kili-operation-page-lite\\kili_admin_view\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65dd717d"]])

export default __exports__